import { render, staticRenderFns } from "./pnlReserveItems.vue?vue&type=template&id=f604a6c0&"
import script from "./pnlReserveItems.vue?vue&type=script&lang=ts&"
export * from "./pnlReserveItems.vue?vue&type=script&lang=ts&"
import style0 from "./pnlReserveItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports